<script setup lang="ts">
// @ts-ignore
import AppController from "@target/components/App/ts/AppController";

function toRules() {
    AppController.getInstance().routerService.toRulesAsPopup();
}
</script>

<template>
    <div class="payment-rules">
        <p>{{ $t('payment.rules.text') }} <span class="link" @click="toRules">{{ $t('payment.rules.link') }}</span></p>
    </div>
</template>

<style scoped lang="scss">
.payment-rules {
    padding: 12px 16px;
    border-radius: 18px;
    background-color: #F7F7F8;

    p {
        @include text(12px, 400, var(--grey2), 120%);

        .link {
            color: var(--blue1);
        }
    }
}
</style>
